/**
 * The stats-window filter, as the pickers read it: one option per window in
 * display order, plus the parse every screen needs to restore a saved pick.
 * Pure — no storage, no React.
 */
import {
  DEFAULT_STATS_WINDOW,
  STATS_WINDOWS,
  isStatsWindow,
  windowLabel,
  type StatsWindow,
} from '@tv-casino/shared';

export interface WindowOption {
  id: StatsWindow;
  label: string;
}

/** The chips the picker prints, in display order. */
export function windowOptions(): readonly WindowOption[] {
  return STATS_WINDOWS.map((id) => ({ id, label: windowLabel(id) }));
}

/** A saved or URL-borne window name; anything unknown falls back to tonight. */
export function parseStatsWindow(raw: string | null | undefined): StatsWindow {
  return isStatsWindow(raw) ? raw : DEFAULT_STATS_WINDOW;
}
